export default {"src":"/_next/static/media/menu.92528ca5.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};